export default {
  init() {
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    const ratesRooms = $('.section-rates-rooms');
    if (ratesRooms.length) {
      ratesRooms.on('click', '.room-info .mobile-more-info', function () {
        const mobileMoreInfo = $(this);
        mobileMoreInfo.toggleClass('collapsed');
        const room = mobileMoreInfo.parents().closest('.room-info');
        const roomDescCollapse = room.find('.room-desc-collapse').get(0);

        if (mobileMoreInfo.hasClass('collapsed')) {
          roomDescCollapse.style.height = null;
        } else {
          roomDescCollapse.style.height = roomDescCollapse.scrollHeight + 'px';
        }
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateGlobalRates.js